<template>
  <transition name="slide-up">
    <div v-if="show"
      class="modal"
      tabindex="-1"
      @click.self="close">
      <div class="modal-dialog" @click.stop="">
        <div class="modal-content">
          <div v-if="showHeader" class="modal-header">
            <h5 v-if="$slots.header" class="modal-title">
              <slot name="header" />
            </h5>

            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="$emit('close')">
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>

          <div class="modal-body">
            <slot />
          </div>

          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TheModal',

  props: {
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    },

    closeOverlay: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  created() {
    setTimeout(() => {
      this.show = !this.show;
      document.body.classList.add('overflow-hidden');
    }, 150);
  },

  mounted() {
    document.addEventListener('keydown', this.triggerKey);
  },

  beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.triggerKey);
    this.show = !this.show;
  },

  methods: {
    closeModal() {
      this.show = !this.show;

      setTimeout(() => {
        this.$emit('close');
      }, 150);
    },

    triggerKey(event) {
      if (event.keyCode !== 27) return;
      this.closeModal();
    },

    close() {
      if (this.closeOverlay) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
  .modal {
    display: block;
    background-color: rgba($black, 0.5);

    .modal-dialog {
      max-width: 640px;
      box-shadow: 0 1.5rem 1rem -0.5rem rgba($black, 0.35);
    }

    .modal-content {
      border-radius: 0.5rem;
      overflow: hidden;
    }

    .modal-footer {
      .btn {
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 500;
      }
    }
  }
</style>
